import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
import { trackPixelEvent } from './MetaPixel';
type FloatingCTAProps = {
  /** Element id the floating bar should appear after (the first CTA). */
  triggerId: string;
};
export function FloatingCTA({
  triggerId
}: FloatingCTAProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const trigger = document.getElementById(triggerId);
    if (!trigger) return;
    const onScroll = () => {
      const rect = trigger.getBoundingClientRect();
      setVisible(rect.bottom < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, [triggerId]);
  return <AnimatePresence data-id="element-33" data-mp="33ifllrz4vugk">
      {visible ? <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-navy-900/10 bg-white/95 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur-md sm:px-6" data-id="element-34" data-mp="2z30l59usf402">
          <div className="mx-auto flex max-w-2xl flex-col items-center gap-2" data-id="element-35" data-mp="2fdozck4jehgy">
            <a href={CHECKOUT_URL} onClick={() => trackPixelEvent('InitiateCheckout', {
          value: 27,
          currency: 'USD'
        })} className="kd-shake flex w-full items-center justify-center gap-2 rounded-2xl bg-brick-600 px-4 py-3.5 text-[14px] font-extrabold uppercase tracking-wide text-white shadow-[0_10px_26px_-8px_rgba(207,32,39,0.7)] transition-colors duration-150 ease-out hover:bg-brick-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brick-700 sm:text-base" data-id="element-36" data-mp="2kdkv5w32z2lf">
              Get Kidney Disease Route™ — $27
              <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-37" data-mp="34i4vvcmquu3" />
            </a>
            <p className="text-[11px] font-semibold uppercase tracking-wide text-navy-500" data-id="element-38" data-mp="3ua9jbxh1oj12">
              Instant access • Lifetime • 7-day guarantee
            </p>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}